import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Wrapper = styled.div`
  margin-top: 10px;
  margin: 15px;
  border-radius: 20px;
  background-color: ${theme.colors.darkBlue};
  color: ${theme.colors.white};

  @media screen and (max-width: 360px) {
    margin: 1rem 0;
  }
`;

export const GridStyled = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  overflow-x: auto;
  width: 100%;
`;

export const PaginateInfo = styled.span`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  font-family: "poppins";
  font-weight: 400;
  font-size: 0.8rem;
  color: ${theme.colors.primary};
`;

export const HeaderStyled = styled.div`
  display: flex;
  padding: 10px 15px;
  border-radius: 20px 20px 0 0;
  background-color: ${theme.colors.darkBlue};
  color: ${theme.colors.white};
  width: 100%;
  min-width: fit-content;

  span {
    flex: 1;
    text-align: left;
    min-width: 140px;
  }
`;

export const CelTable = styled.div`
  padding: 10px 15px 10px 10px;
  height: 50px;
  font-family: "poppins";
  font-size: 0.8rem;
  font-weight: 400;
  flex: 1;
  align-items: center;
  display: flex;
  line-break: anywhere;
  min-width: 140px;
`;

type RowProp = {
  index: number;
};

export const RowTable = styled.div<RowProp>`
  padding: 5px 10px;
  width: 100%;
  display: flex;
  background-color: ${(p) =>
    p.index % 2 === 0 ? theme.colors.blue900 : theme.colors.blue800};
  max-height: 65px;
  border-radius: 16px;
  margin-bottom: 5px;
  cursor: pointer;
  flex-shrink: 0;
  min-width: fit-content;
`;

export const Itemheader = styled.span`
  padding: 10px 10px;
  width: 100%;
  font-family: "poppins";
  color: ${theme.colors.white};
  font-size: 0.8rem;
  font-weight: 500;

  @media screen and (max-width: 479px) {
    padding: 10px 15px;
  }
`;

export const BodyTableStyled = styled.div`
  padding: 10px 10px;
  width: 100%;
`;

export const PaginateStyled = styled.div`
  padding: 10px 30px;
  display: flex;
  justify-content: center;

  ul {
    list-style: none;
    display: flex;

    li {
      font-family: "poppins";
      font-weight: 400;
      font-size: 0.8rem;
      padding: 0px;
      color: ${theme.colors.darkGray};
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: ease all 50ms;

      :hover,
      :hover a {
        background-color: ${theme.colors.blue100};
        color: ${theme.colors.darkBlue};
        opacity: 0.8;
        border-radius: 4px;
      }
      margin: 0 2px;
    }

    a {
      width: 25px;
      height: 31px;
      justify-content: center;
      align-items: center;
      display: flex;
    }

    .previous,
    .next-button,
    .next {
      a {
        font-size: 1rem;
        color: ${theme.colors.darkGray};
        padding: 0;
        background-color: ${theme.colors.blue900};
        border-radius: 4px;
        text-decoration: none;
      }
    }

    .selected {
      background-color: ${theme.colors.blue100};
      color: ${theme.colors.darkBlue};
      border-radius: 4px;
    }
  }
`;
